<template>
  <list-layout :tableTools="toggleTableTools">
    <template slot="header">
      <BaseHeader :content="header" data-v-step="4"/>
    </template>
    <template slot="table-core">
      <base-table-pagination
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags  :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component">
      <kendo-grid-component
        ref="grid"
        v-model="selected"
        :value-key="['idCliente', 'IdCIFEmpresa']"
        :id-vista="idVista"
        :spanish="spanish"
        :data="data"
        :kendo="kendo"
        :loading="isGeneralLoading"
        :selectedField="selectedField"
        @actionclick="openPath"
        @datastatechange="dataStateChange">
      </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <div class="mt-5 mb-5"></div>
          <base-button-responsive mode="primary" :text="labelBtnExcel" icon="excelxls" @click="exportExcel" :loading="isGeneralLoading || loadingExcel" :disabled="loadingExcel"/>
          <base-button-responsive v-if="hasModuleImportaciones && !isRoleUserOrConsulta" mode='primary' :text="$t('app.import')" icon='import' @click='toggleImport' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
          <base-button-responsive v-if="!isRoleUserOrConsulta" mode="primary" :text="$t('companies.new_company')" icon="plus" @click="goToNewCompany" :loading="isGeneralLoading"/>
        </template>
      </base-footer>
      <base-table-select-actions-expand
        :baseDropDownVisible="accionesEmpresas.length > 0"
        :visibility="hasSelected"
        :selected="rowsSelected"
        :total="rowsTotal"
      >
        <template slot="commons">
          <base-button size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" />
            {{$t('app.unselect')}}
          </base-button>
        </template>
        <template slot="more">
          <span v-for="action in accionesEmpresasFinal" :key="action.idKey">
              <base-button-item-list theme="dark"  @click="executeAction(action)">
                  <base-icon :name="selectIcon(action)" class="mr-2" />
                    <div class="w-56 text-left">
                      {{ action.name }}
                    </div>
            </base-button-item-list>
          </span>
          <!-- <span>
             <base-button-item-list theme="dark" @click="deleteCompany">
              <base-icon name="trash" class="mr-2" />
              Borrar2
            </base-button-item-list>
          </span> -->
        </template>
      </base-table-select-actions-expand>
      <company-grouping-dialog 
        :dialogOpen="showModalGrouping" 
        @toggleDialog="toggleModalGrouping" 
        @applyDialog="applyModalGrouping"
        :header="$t('grouping.link_to_group')" 
        :headerValue="$t('grouping.group_name')" 
        :idCliente="selectedIdCliente"
        />
      <Dialog
            :title="$t('companies.delete_company')"
            :visible.sync="showModal"
            width="40%"
            custom-class="min-width-dialog"
            center>
            <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessage }}</span>
            <template slot="footer" >
              <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
                <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
                <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {deleteHandler(); showModal = false}"/>
              </div>
            </template>
        </Dialog>
      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" />
      <create-search-dialog 
        :numberSearches="numberSearches"
        :idVista="idVista" 
        :dialogOpen="saveSearchDialog" 
        :tags="tags" 
        @toggleDialog="toggleDialogSearches" 
        @applyDialog="applySearchHandler" />
      <filter-panel-searches 
        ref="filterPanelSearches" 
        :idVista="idVista" 
        :vuexnamespace="vuexnamespace" 
        :panelOpen="searchesPanel" 
        @togglePanel="toggleSearchesDialog" 
        @applyFilters="applyFiltersHandler" 
        @updateNumberSearches="updateNumberSearches"/>
        
      <import-generic-dialog
        :dialogOpen="showModalImport"
        :mandatoryClient="true"
        :activateSwitch1="true"
        :labelSwitch1="$t('imports.excel_import_options_update')"
        :sizeLg="role !== 2"
        @toggleDialog="toggleImport" 
        @applyDialog="applyImport"
        @downloadTemplate="downloadTemplate"
        :header="$t('imports.import_companies_header')" 
        />
    </template>
  </list-layout>
</template>

<script>
import { bus } from '@/main'
import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/CompaniesFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'
import { getCompanies } from '@/services/companies/getCompanies'
import { i18n } from '@/i18n'
// import { saveExcel } from '@progress/kendo-vue-excel-export'
import KendoGridComponent from '@/components/KendoGridComponentV2.vue'
import CompanyGroupingDialog from '@/components/CompanyGroupingDialog.vue'
// import moment from 'moment'

import { downloadExcel } from '@/services/companies/downloadExcel'
import { load } from '@progress/kendo-vue-intl'
import likelySubtags from 'cldr-core/supplemental/likelySubtags.json'
import currencyData from 'cldr-core/supplemental/currencyData.json'
import weekData from 'cldr-core/supplemental/weekData.json'
import numbers from 'cldr-numbers-full/main/es/numbers.json'
import currencies from 'cldr-numbers-full/main/es/currencies.json'
import caGregorian from 'cldr-dates-full/main/es/ca-gregorian.json'
import dateFields from 'cldr-dates-full/main/es/dateFields.json'
import timeZoneNames from 'cldr-dates-full/main/es/timeZoneNames.json'
import { Dialog } from 'element-ui'
// import { deleteCompany } from '@/services/companies/deleteCompany'
import { updateStateCompanies } from '@/services/companies/updateStateCompanies'
import { linkGroupingCompaniesName } from '@/services/configurations/grouping/linkGroupingCompaniesName'

// Imports
import ImportGenericDialog from '@/components/ImportGenericDialog.vue'
import { importCompanies } from '@/services/configurations/imports/importCompanies'
import { downloadTemplateCompanies } from '@/services/configurations/imports/downloadTemplateCompanies'

load(
  likelySubtags,
  currencyData,
  weekData,
  numbers,
  currencies,
  caGregorian,
  dateFields,
  timeZoneNames
)

export default {
  name: 'companies-list-view',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    CompanyGroupingDialog,
    CreateSearchDialog,
    KendoGridComponent,
    Dialog,
    ImportGenericDialog,
  },
  data: function () {
    return {
      idVista: 4,
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      // Import
      showModalImport: false,
      // All
      showModalGrouping: false,
      loadingExcel: false,
      spanish: true,
      showModal: false,
      header: {
        title: i18n.t('companies.header'),
        icon: 'companies',
        breadcrumb: null,
        url: null
      },
      vuexnamespace: 'companies',
      hasClientFilterData: false,
      selectedField: 'selected',
      filterPanel: false,
      showAllRows: true,
      loadingDataTable: false,
      data: null,
      selected: [],
      processMessage: i18n.t('app.delete_selected_confirmation_f', { entity: i18n.tc('companies.entity_name', 2).toLowerCase() })
    }
  },
  computed: {
    hasModuleImportaciones () {
      return this.$store.getters['auth/hasImportacionesModule']
    },
    hasAnyImportaciones () {
      return this.$store.getters['auth/hasAnyImportaciones']
    },
    accionesEmpresas: function () {
      return this.$store.getters['config/ACCIONES_EMPRESAS']
    },
    isClientFilterActive () {
      return this.$store.getters[this.vuexnamespace + '/isClientFilterActive']
    },
    actualFilterNav () {
      return this.$store.getters['app/idClienteFilterNav']
    },
    selectedIdCliente () {
      return this.hasSelected ? this.selected[0].idCliente : null
    },
    hasModuleAgrupaciones () {
      return this.$store.getters['auth/hasAgrupacionesModule']
    },
    hasModuleSEPA () {
      return this.$store.getters['auth/hasSEPAModule']
    },
    accionesEmpresasFinal () {
      let accionesFinal = this.accionesEmpresas
      if (this.hasSelected) {
        const idCliente = this.selectedIdCliente
        if (this.isRoleConsulta || this.selected.length > 1 || !this.hasModuleSEPA) {
          accionesFinal = accionesFinal.filter(x => x.idKey !== 13)
        }
        if (this.selected.filter(x => x.idCliente === idCliente).length !== this.selected.length) {
          accionesFinal = accionesFinal.filter(x => x.idKey !== 8 && x.idKey !== 9 && x.idKey !== 10 && x.idKey !== 11 && x.idKey !== 12)
        } else {
          if (!this.hasModuleAgrupaciones) accionesFinal = accionesFinal.filter(x => x.idKey !== 12)
        }
      }
      return accionesFinal
    },
    labelBtnExcel: function () {
      if (this.hasSelected) return `${i18n.t('app.export_excel')} (${i18n.t('app.selected')})`
      return i18n.t('app.export_excel')
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.selected.length
    },
    setLabelTowShow: function () {
      return this.showAllRows ? i18n.t('app.only_selected') : i18n.t('app.see_all')
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleConsulta: function () {
      return this.role === 4
    },
    isRoleUserOrConsulta: function () {
      return this.role === 1 || this.role === 4
    },
    selectIcon: function (action) {
      return (action) =>
        action.id === 2 ? 'trash' 
          : action.id === 5 ? 'editpencil'
            : action.idKey === 12 ? 'groupingadd'
              : action.idKey === 13 ? 'sepa'
                : action.activo ? 'check' : 'cross'
    },
  },
  watch: {
    $route: 'routerChangeHandler',
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
  },
  created: function () {
    if (this.isRoleUserOrConsulta) {
      this.kendo.columns = this.kendo.columns.filter(x => x.field !== 'selected')
    } 
    if (this.$route.params.data) {
      this.filterByParamsData()
    }
  },
  mounted: async function () {
    this.initialice()
  },
  methods: {
    toggleImport () {
      this.showModalImport = !this.showModalImport
    },
    applyImport: async function (file, form) {
      this.$store.commit('setIsLoading', true)
      try {
        const params = { 
          idCliente: form.idCliente,
          actualizarCIFS: form.switch1,
        }
        const response = await importCompanies(file, params)
        if (response.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.toggleImport() 
          this.doFeedback(i18n.t('imports.processing'), 'info')
          if (!this.hasAnyImportaciones) {
            bus.$emit('resetAndUpdateNav', 1000)
          }
          this.$router.push({ name: 'configurations/imports' })
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadTemplate: async function (formIdCliente) {
      this.$store.commit('setIsLoading', true)
      try {
        const params = {
          idCliente: formIdCliente
        }
        const response = await downloadTemplateCompanies(params)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.downloadBlob(response, 'plantilla-importacion-empresas.xlsx')
        }
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    routerChangeHandler: async function () {
      this.filterByParamsData()
      this.initialice()
    },
    initialice: async function () {
      // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      // this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)
      if (this.actualFilterNav && this.isClientFilterActive && !this.hasClientFilterData) {
        const filter = this.masterFilters
        filter.empresa = { label: i18n.t('clients.entity_name'), value: this.actualFilterNav }
        this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      }
      this.data = await this.applyFilters()
    },
    filterByParamsData: function () {
      const data = this.$route.params.data
      const filters = {}
      if (data) {
        data.filters.forEach(filter => {
          if (filter.type === 'cliente') {
            this.hasClientFilterData = true
            const cliente = { label: i18n.t('clients.entity_name'), value: { Nombre: filter.data.label, idCliente: filter.data.id } }
            filters.empresa = cliente
          } else {
            filters[filter.type] = filter.data
          }
        })
        this.$store.commit(this.vuexnamespace + '/setMasterFilters', filters)
      }
    },
    toggleModalGrouping () {
      this.showModalGrouping = !this.showModalGrouping
    },
    openPath: function (event) {
      this.$router.push({ name: 'companies/detail', params: { id: event.dataItem.IdCIFEmpresa } })
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    dataStateChange: async function (event) {
      this.data = await this.applyFilters()
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const user = this.$store.getters['auth/user']
      const params = {
        idUsuario: user.IdUsuario,
        CIF: data.cif ? data.cif.value : null,
        razonSocial: data.name ? data.name.value : null,
        fechaAltaDesde: data.fechaAltaDesde ? data.fechaAltaDesde.value : null,
        fechaAltaHasta: data.fechaAltaHasta ? data.fechaAltaHasta.value : null,
        idDistribuidor: data.distribuidor ? data.distribuidor.value?.idDistribuidor : null,
        idCliente: data.empresa ? data.empresa.value?.idCliente : null,
        estado: data.estado ? data.estado.value : null,
        email: data.email ? data.email.value : null,
        enviarAvisos: data.send_alerts ? data.send_alerts.value : null,
        certAsociado: data.certAsociado ? data.certAsociado.value : null,
        nombreAgrupacion: data.nombreAgrupacion ? data.nombreAgrupacion.value : null,
        firmaDelegada: data.firmaDelegada ? data.firmaDelegada.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
      const payload = { order: objOrder.order, grupos: objColumnas }
      if (data.ActiveReports) {
        payload.ActiveReports = data.ActiveReports.value
      }
      if (this.hasSelected) {
        payload.listaIDs = this.selected.map(x => x.IdCIFEmpresa)
      }
      try {
        const response = await downloadExcel(payload, params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'empresas.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      this.$store.commit(this.vuexnamespace + '/setClientFilterActive', !!((data.empresa && data.empresa.value.idCliente === this.actualFilterNav?.idCliente) || (this.hasClientFilterData)))
      const user = this.$store.getters['auth/user']
      const params = {
        idUsuario: user.IdUsuario,
        CIF: data.cif ? data.cif.value : null,
        razonSocial: data.name ? data.name.value : null,
        fechaAltaDesde: data.fechaAltaDesde ? data.fechaAltaDesde.value : null,
        fechaAltaHasta: data.fechaAltaHasta ? data.fechaAltaHasta.value : null,
        idDistribuidor: data.distribuidor ? data.distribuidor.value?.idDistribuidor : null,
        idCliente: data.empresa ? data.empresa.value?.idCliente : null,
        estado: data.estado ? data.estado.value : null,
        email: data.email ? data.email.value : null,
        enviarAvisos: data.send_alerts ? data.send_alerts.value : null,
        certAsociado: data.certAsociado ? data.certAsociado.value : null,
        nombreAgrupacion: data.nombreAgrupacion ? data.nombreAgrupacion.value : null,
        firmaDelegada: data.firmaDelegada ? data.firmaDelegada.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      if (data.ActiveReports) {
        objOrder.ActiveReports = data.ActiveReports.value
      }
      try {
        const data = await this.getItemsData(objOrder, params)
        return data
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(i18n.t('feedback.error.general'))
      }
      return this.data
    },
    getItemsData: async function (objOrder, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(objOrder, params)
      this.data = res.respuesta
      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false
      return this.data
    },
    async getMainData (objOrder, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getCompanies(objOrder, params)
      if (data.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
      }
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters(null)
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      this.data = await this.applyFilters(null)
    },
    removeFilterTagHanlder: function (tag) {
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.applyFiltersHandler(null)
    },
    headerCoreFiltersHandler: function (obs) {
      if (this.isHeadCoreReady) {
        this.applyFilters(null)
      }
    },
    removeAllTagsHandler: function () {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.applyFiltersHandler(null)
    },
    unselect: function () {
      this.selected = []
    },
    deleteCompany: async function () {
      this.showModal = !this.showModal
    },
    goToNewCompany: function () {
      this.$router.push({ name: 'companies/detail', params: { id: -1 } })
    },
    deleteHandler: async function () {
      this.executeActionHandler()
    },
    executeAction: async function (action) {
      this.selectedAction = action
      // this.executeActionHandler()
      if (this.selectedAction.id === 4) { // borrar
        this.showModal = true
      } else if (this.selectedAction.id === 12) {
        this.toggleModalGrouping()
      } else if (this.selectedAction.id === 5) { // Plantilla modo por campos
        const data = {
          companies: this.selected
        }
        
        const idCliente = this.selected.map(x => x.idCliente)[0]
        if (this.role === 7 || this.role === 8 || this.role === 3) {
          this.$router.push({ name: 'configurations/clients/template/companies', params: { data: data, id: idCliente } })
        } else {
          this.$router.push({ name: 'configurations/template/companies', params: { data: data } })
        } 
      } else if (this.selectedAction.id === 13) { // SEPA
        const data = {
          id: this.selected[0].IdCIFEmpresa
        }
        this.$router.push({ name: 'companies/sepa', params: { ...data } })
      } else {
        this.executeActionHandler()
      }
    },
    executeActionHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const idCIFS = []
        this.selected.forEach(element => {
          idCIFS.push(element.IdCIFEmpresa)
        })
        const IdAccion = this.selectedAction.id
        const boolAccion = this.selectedAction.activo
        this.$store.commit('setIsLoading', true)
        const response = await updateStateCompanies({ idCifsEmpresa: idCIFS, accion: IdAccion, valor: boolAccion })
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.unselect()
        this.$store.commit('setIsLoading', false)
        await this.applyFilters()
      }
    },
    applyModalGrouping: async function (nombre) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { Nombre: nombre, idCifEmpresas: this.selected?.map(x => x.IdCIFEmpresa) }
        const response = await linkGroupingCompaniesName(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
          this.toggleModalGrouping()
          await this.applyFilters()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
